import { render, staticRenderFns } from "./ScreenStepsRow.vue?vue&type=template&id=d96b80f6"
import script from "./ScreenStepsRow.vue?vue&type=script&lang=ts"
export * from "./ScreenStepsRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports